import { AdminModule } from './admin/admin.module';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';


import { AppComponent } from './app.component';
import { StarterComponent } from './starter/starter.component';
import { StarterHeaderComponent } from './starter/starter-header/starter-header.component';
import { StarterLeftSideComponent } from './starter/starter-left-side/starter-left-side.component';
import { StarterContentComponent } from './starter/starter-content/starter-content.component';
import { StarterFooterComponent } from './starter/starter-footer/starter-footer.component';
import { StarterControlSidebarComponent } from './starter/starter-control-sidebar/starter-control-sidebar.component';
import { AdminComponent } from './admin/admin.component';
import { AdminHeaderComponent } from './admin/admin-header/admin-header.component';
import { AdminLeftSideComponent } from './admin/admin-left-side/admin-left-side.component';
import { AdminContentComponent } from './admin/admin-content/admin-content.component';
import { AdminFooterComponent } from './admin/admin-footer/admin-footer.component';
import { AdminControlSidebarComponent } from './admin/admin-control-sidebar/admin-control-sidebar.component';
import { AdminDashboard1Component } from './admin/admin-dashboard1/admin-dashboard1.component';



/* PROJECT COMPONENTS AND PROVIDERS */
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';

/* GUARDS */
import { LoginGuard } from './guards/login-guard';
/* END GUARDS */

/** PROVIDERS */
import { AuthProvider } from './providers/auth/auth';
import { HttpClient } from './providers/http-client';
import { UserData } from './providers/local/user-data';
import { Config } from './providers/local/config';
import { IonicAngularProvider } from './providers/ionic-angular/ionic-angular';
import { ClientProvider } from './providers/client/client';
import { UserProvider } from './providers/user/user';
import { LoanProvider } from './providers/loan/loan';
import { TransactionProvider } from './providers/transaction/transaction';

/** COMPONENTS */
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { ClientListComponent } from './pages/client-list/client-list.component';
import { CreditListComponent } from './pages/credit-list/credit-list.component';
import { ClientMapComponent } from './pages/client-map/client-map.component';
import { AuthorizationListComponent } from './pages/authorization-list/authorization-list.component';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { BalancesComponent } from './pages/balances/balances.component';

@NgModule({
  declarations: [
    AppComponent,
    StarterComponent,
    StarterHeaderComponent,
    StarterLeftSideComponent,
    StarterContentComponent,
    StarterFooterComponent,
    StarterControlSidebarComponent,

    /* PROJECT COMPONENTS */
    LoginComponent,
    HomeComponent,
    ClientListComponent,
    CreditListComponent,
    ClientMapComponent,
    AuthorizationListComponent,
    DateFormatPipe,
    BalancesComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AdminModule,

    /* PROJECT COMPONENTS */
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule
  ],
  providers: [
    /* PROJECT PROVIDERS */
    LoginGuard,

    HttpClient,
    UserData,
    Config,

    AuthProvider,
    IonicAngularProvider,
    ClientProvider,
    UserProvider,
    LoanProvider,
    TransactionProvider,
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 

  constructor(public userData: UserData) {
    this.userData.init();
  }
}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/app.module.ts